import React from "react";

const NotFound = () => {
  return (
    <div className="container text-center mt-1">
      <img
        src="https://i.ibb.co/6tKF94q/404.png"
        alt=""
        className="img-fluid"
      />
      <h2>Oops! Page Not Available</h2>
    </div>
  );
};

export default NotFound;
